export const GRADIENTS = {
    background: {
        primary: 'from-gray-100 to-gray-200 dark:from-black dark:to-gray-900',
        alternative: 'from-blue-50 via-gray-50 to-purple-50 dark:from-gray-900 dark:via-blue-900 dark:to-gray-900',
        overlay: 'from-white/50 to-transparent dark:from-gray-900/50',
    },
    text: {
        primary: 'from-blue-500 to-blue-700 dark:from-blue-400 dark:to-blue-600',
        secondary: 'from-blue-500 to-blue-800',
        accent: 'from-blue-600 via-blue-500 to-blue-700 dark:from-blue-400 dark:via-blue-400 dark:to-blue-500',
    },
    button: {
        primary: 'from-blue-500 to-blue-700 dark:from-blue-600 dark:to-blue-400',
        secondary: 'from-blue-500 to-blue-800',
        hover: 'hover:from-blue-600 hover:to-blue-900',
    }
};

export const COLORS = {
    text: {
        primary: 'text-gray-900 dark:text-gray-100',
        secondary: 'text-gray-700 dark:text-gray-300',
        accent: 'text-blue-900 dark:text-blue-400',
    },
    background: {
        glass: 'bg-white/30 dark:bg-gray-900/30',
        lightGlass: 'bg-white dark:bg-red-400/30',
        input: 'bg-white/50 dark:bg-gray-800/50',
    },
    border: {
        primary: 'border-gray-200 dark:border-gray-700',
        secondary: 'border-blue-700 dark:border-blue-900',
        glass: 'border-white/50 dark:border-gray-700/50',
    },
    shadow: {
        primary: 'shadow-gray-500/50 dark:shadow-gray-900/50 ',
        secondary: 'shadow-blue-500/50 dark:shadow-blue-900/50',
    }
};
